import { MouseEvent, MouseEventHandler, useCallback, useState } from 'react';
import { ReservationGeneral } from '../models/ReservationGeneral';
import useReservationUIConfig from '../models/useReservationUIConfig';

export function useExternalRevenueActionGuard(reservation?: ReservationGeneral) {
  const { Channel_Revenue_Restricted } = useReservationUIConfig(reservation);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const closePopover = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const guardAction = useCallback(
    (handler: (event: MouseEvent<HTMLElement>) => void): MouseEventHandler =>
      (event) => {
        if (Channel_Revenue_Restricted) {
          setAnchorEl(event.currentTarget as HTMLElement);
          return;
        }
        handler(event as MouseEvent<HTMLElement>);
      },
    [Channel_Revenue_Restricted]
  );

  return {
    guardAction,
    popoverProps: {
      anchorEl,
      onClose: closePopover,
    },
  };
}
